//import { StringUtils } from '@azure/msal-browser';
//import { first, last } from 'rxjs/operators';
import { Roles } from 'src/app/core/roles/role-settings.model';
import { SiteModel } from 'src/app/jj/models/site.model';
//import internal from 'stream';

export class ReportDetail {
    reportId: string;
    reportName: string;
    reportTitle: string;
    owner: string;
    isSelected: boolean;

    public static modelMapper(uiModel: ReportDetail) {
        return {
            reportId: uiModel.reportId,
            reportName: uiModel.reportName,
            reportTitle: uiModel.reportTitle,
            accessEnabled: uiModel.isSelected
        };
    }

    public uiMapper(modelData: any) {
        Object.assign(this, modelData, {
            reportId: modelData['reportId'],
            reportName: modelData['reportName'],
            reportTitle: modelData['reportTitle'],
            owner: modelData['owner'],
            isSelected: true
        });
        return this;
    }

    public clone(data: any) {
        Object.assign(this, {
            reportId: data.reportId,
            reportName: data.reportName,
            reportTitle: data.reportTitle,
            owner: data.owner,
            isSelected: data.isSelected,
        });
        return this;
    }
}

export class ReportsList {
    reports: Array<ReportDetail> = [];

    public dataMapper(modelData: ReportDetail[]) {
        return Object.assign(modelData ? modelData.map(data => {
                                    return  Object.assign(ReportDetail.modelMapper(data));
                                }) : []);
    }

    public uiMapper(modelData: any) {
        Object.assign(this, {
            reports: modelData ?
                        modelData.map(data => {
                            return  Object.assign(new ReportDetail().uiMapper(data));
                        }) : []
        });

        return this;
    }

    public clone(modelData: any) {
        Object.assign(this, {
            reports: modelData ?
                        modelData.map(data => {
                            return  Object.assign(new ReportDetail().clone(data));
                        }) : []
        });

        return this;
    }
}
export class RoleDetails{
    name:string;
    description:string;
    role:Roles
}
export class UserDetail {
    id: string;
    surName: string;
    userPrincipalName: string;
    preferredLanguage: string;
    officeLocation: string;
    mobilePhone: string;
    mail: string;
    jobTitle: string;
    givenName: string;
    fullName: string;
    businessPhones: Array<string>;
    isAdmin: boolean;
    isModerator: boolean;
    isSuperAdmin: boolean;
    isEmailNotification: boolean;
    isNew: boolean;
    isDeleted: boolean;
    isModified: boolean;
    // role: Array<Roles>;
    roles:Array<RoleDetails>;
    // roleName:string;
    unit: string;
    isPending: boolean;
    accessEnabled: boolean;
    businessUnit: string;
    reports: Array<ReportDetail>;
    organization:string;
    contact:string;
    founded:number;
    staffSize:number;
    headquarter:string;
    url:string;
    isActive:boolean;
    sites: Array<SiteModel>;
    oktaStatus:string;
    public static addRole(uiModel: any, role: RoleDetails) {
        return {
            id: uiModel['id'],
            isNew: uiModel['isNew'],
            isDeleted: uiModel['isDeleted'],
            isModified: uiModel['isModified'],
            isAdmin: Roles.Admin === role.role,
            isModerator: Roles.Moderator === role.role,
            isSuperAdmin: Roles.SuperAdmin === role.role
        };
    }

    public static modelMapper(uiModel: UserDetail) {
        return {
            id: uiModel.id,
            isAdmin: uiModel.roles.some(v => v.role === Roles.Admin),
            isModerator: uiModel.roles.some(v => v.role === Roles.Moderator),
            isSuperAdmin : uiModel.roles.some(v => v.role === Roles.SuperAdmin),
            isEmailNotification: uiModel.isEmailNotification,
            isNew: uiModel.isNew,
            isDeleted: uiModel.isDeleted,
            isModified: uiModel.isModified,
        };
    }

    public static userReportModelMapper(uiModel: UserDetail) {
        return {
            userid: uiModel.id,
            fullName: uiModel.fullName,
            accessEnabled: uiModel.reports && uiModel.reports.findIndex(x => x.isSelected) >= 0,
            reports: new ReportsList().dataMapper(uiModel.reports)
        };
    }

    private mapRole(roleData:any){
        const rd = new RoleDetails();
        rd.name = roleData.name;
        rd.description = roleData.description;
        rd.role = Roles[roleData.name as keyof typeof Roles];
        return rd;
    }

    public uiMapper(modelData: any) {
        Object.assign(this, modelData, {
            roles: modelData.roles && Array.isArray(modelData.roles) ? modelData.roles.map(r =>  this.mapRole(r)) : [],
            unit: modelData['department'],
            isActive:modelData['isActive']
        });
        return this;
    }

    private getRole(modelData: any) {
        let roleList: Roles[] = [];
        if (modelData['isAdmin']) {
            roleList.push(Roles.Admin);
        } 
        if (modelData['isModerator']) {
            roleList.push(Roles.Moderator);
        } 
        if (modelData['isSuperAdmin']) {
            roleList.push(Roles.SuperAdmin);
        }
        roleList.push(Roles.User);
        return roleList
    }

    private getRoleName(modelData: any) {
        let roleList: string[] = [];
        if (modelData['isAdmin']) {
            roleList.push('Admin');
        } 
        if (modelData['isModerator']) {
            roleList.push('Moderator');
        }
        if (modelData['isSuperAdmin']) {
            roleList.push('SuperAdmin');
        } 
        
        if (!modelData['isSuperAdmin'] 
            && !modelData['isModerator'] 
            && !modelData['isAdmin'] 
            && modelData.roles != null) {
            modelData['roles'].forEach(r => {
                roleList.push(r.name);
            });
        }
        else {
            return ['User'];
        }
    }

    public userReportUiMapper(modelData: any) {
        Object.assign(this, modelData, {
            id: modelData['userId'],
            unit: modelData['businessUnit'],
            fullName: modelData['givenName'] + ' ' + modelData['surName'],
            reports: new ReportsList().uiMapper(modelData['reports']).reports
        });
        return this;
    }

    public userOtherUnitUiMapper(modelData: any) {
        Object.assign(this, modelData, {
            id: modelData['id'],
            userPrincipalName: modelData['userPrincipalName'],
            fullName: modelData['givenName'] + ' ' + modelData['surName'],
            unit: modelData['department']
        });
        return this;
    }

    public updateRole(role: RoleDetails) {
        this.roles.push(role);
        this.isAdmin = Roles.Admin === role.role;
        this.isModerator = Roles.Moderator === role.role;
        this.isSuperAdmin = Roles.SuperAdmin === role.role;
        this.isPending = true;
    }

    public updateReportAccess(reports) {
        this.isPending = true;
        this.reports = new ReportsList().clone(reports).reports;
    }

    public addUser(email:string,firstName:string,lastName:string,title:string,organization:string,isActive:boolean,sites:Array<SiteModel>,roles:Array<RoleDetails>){
        Object.assign(this, {
        userPrincipalName :email,
        givenName:firstName,
        surName:lastName,
        jobTitle:title,
        organization:organization,
        isAdmin : roles.some(r => r.role === Roles.Admin) ? true:false,
        isModerator : roles.some(r => r.role === Roles.Moderator) ? true:false,
        isActive:isActive,
        sites:sites,
        roles:roles,
        // Backend expects capital 'R' Role for primary role and Roles for array
        Role: roles.length > 0 ? roles[0] : null,
        Roles: roles
        });
        return this;
    }

    
}

export class UsersList {
    kmsUsers: Array<UserDetail> = [];

    public static getMappedUser(modelData: UserDetail[]) {
        return Object.assign(modelData ? modelData.map(data => {
            return  data.userPrincipalName;
        }) : []);
    }

    public dataMapper(modelData: UserDetail[]) {
        return Object.assign(modelData ? modelData.map(data => {
                                    return  Object.assign(UserDetail.modelMapper(data));
                                }) : []);
    }

    public userReportDataMapper(modelData: UserDetail[]) {
        return Object.assign(modelData ? modelData.map(data => {
                                    return  Object.assign(UserDetail.userReportModelMapper(data));
                                }) : []);
    }

    public uiMapper(modelData: any) {
        Object.assign(this, {
            kmsUsers: modelData ?
                        modelData.map(data => {
                            return  Object.assign(new UserDetail().uiMapper(data));
                        }) : []
        });

        return this;
    }

    public userReportUiMapper(modelData: any) {
        Object.assign(this, {
            kmsUsers: modelData ?
                        modelData.map(data => {
                            return  Object.assign(new UserDetail().userReportUiMapper(data));
                        }) : []
        });

        return this;
    }

    public userOtherUnitUiMapper(modelData: any) {
        Object.assign(this, {
            kmsUsers: modelData ?
                        modelData.result.map(data => {
                            return  Object.assign(new UserDetail().userOtherUnitUiMapper(data));
                        }) : []
        });

        return this;
    }
}

export class BulkUploadUserStatus {
    totalRows:number;
    invalidEmailAddressRows: string;
    invalidFirstNameRows:string;
    invalidLastNameRows:string;
    invalidRoleRows:string;
    usersAlreadyExists:string;
    importedUsers:any;
}